/**
 * Dealer Network AdminService API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { ExperianCountrySettingsDto } from '../model/experianCountrySettingsDto';
import { ExperianCredentialsDto } from '../model/experianCredentialsDto';
import { ExperianTermsAndConditionsUrlDto } from '../model/experianTermsAndConditionsUrlDto';
import { VPError } from '../model/vPError';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ExperianViewService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Lazy check AmsAction:GET/api/ExperianView/country/{countryId}/CountrySettings AmsResource:{country}/_* 
     * @param countryId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getExperianCountrySettings(countryId: string, observe?: 'body', reportProgress?: boolean): Observable<ExperianCountrySettingsDto>;
    public getExperianCountrySettings(countryId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ExperianCountrySettingsDto>>;
    public getExperianCountrySettings(countryId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ExperianCountrySettingsDto>>;
    public getExperianCountrySettings(countryId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (countryId === null || countryId === undefined) {
            throw new Error('Required parameter countryId was null or undefined when calling getExperianCountrySettings.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ExperianCountrySettingsDto>(`${this.basePath}/api/ExperianView/country/${encodeURIComponent(String(countryId))}/CountrySettings`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/ExperianView/Credentials AmsResource:{country}/{business}/_* 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getExperianCredentials(observe?: 'body', reportProgress?: boolean): Observable<ExperianCredentialsDto>;
    public getExperianCredentials(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ExperianCredentialsDto>>;
    public getExperianCredentials(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ExperianCredentialsDto>>;
    public getExperianCredentials(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ExperianCredentialsDto>(`${this.basePath}/api/ExperianView/Credentials`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/ExperianView/TermsAndConditionUrl AmsResource:{country}/{business}/_* 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getExperianTermsAndConditionUrl(observe?: 'body', reportProgress?: boolean): Observable<ExperianTermsAndConditionsUrlDto>;
    public getExperianTermsAndConditionUrl(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ExperianTermsAndConditionsUrlDto>>;
    public getExperianTermsAndConditionUrl(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ExperianTermsAndConditionsUrlDto>>;
    public getExperianTermsAndConditionUrl(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ExperianTermsAndConditionsUrlDto>(`${this.basePath}/api/ExperianView/TermsAndConditionUrl`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
